export default __webpack_public_path__ + "static/media/success.92f7c327.svg";